import * as Yup from "yup";
import { FORM_ERROR_MESSAGES } from "@shared/constants";

export const formValidationSchema = Yup.object().shape({
  amount: Yup.number()
    .min(0.5, "The entered amount is too small")
    .max(10000, "The entered amount is too big")
    .required(`This ${FORM_ERROR_MESSAGES.REQUIRED}`),
});
